import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ICalculatorState, IFormState, IOption, ISelectedRegion } from '../../types/calculator';

export const initialState: ICalculatorState = {
  displayAllFilters: false,
  selectedRegion: null,
};

/* istanbul ignore next */
export const offerCalculatorSlice = createSlice({
  initialState,
  name: 'calculator',
  reducers: {
    setDisplayAllFilters: (state, action: PayloadAction<boolean>) => {
      state.displayAllFilters = action.payload;
    },
    setBankOptions: (state, action: PayloadAction<IOption[]>) => {
      state.banksOptions = action.payload;
    },
    setRegionsOptions: (state, action: PayloadAction<IOption[]>) => {
      state.regionsOptions = action.payload;
    },
    setDefaultFormState: (state, action: PayloadAction<Partial<IFormState>>) => {
      state.defaultFormState = action.payload;
    },
    setSelectedRegion: (state, action: PayloadAction<ISelectedRegion | null>) => {
      state.selectedRegion = action.payload;
    },
  },
});

export const { setDisplayAllFilters, setRegionsOptions, setBankOptions, setDefaultFormState, setSelectedRegion } =
  offerCalculatorSlice.actions;
